import axios from "axios";
import { addAdvancedErrorManagementInterceptors, addAuthorizationInterceptor, addAwsHeaderInterceptor, } from "./interceptors";
export const createAxiosInstance = ({ disableAwsHeaderInterceptors, disableAdvancedErrorManagement, disableAuthorizer, ...config } = {}) => {
    const instance = axios.create(config);
    if (!disableAdvancedErrorManagement) {
        addAdvancedErrorManagementInterceptors(instance);
    }
    if (!disableAwsHeaderInterceptors) {
        addAwsHeaderInterceptor(instance);
    }
    if (!disableAuthorizer) {
        addAuthorizationInterceptor(instance);
    }
    return instance;
};
//# sourceMappingURL=fetcher.js.map